import React from 'react';
import Banner from './Components/banner';
import EngBan from '../../Assets/images/education-web/engagement-ban.png';
import { Col, Container, Row } from 'react-bootstrap';

import Prongs from '../../Assets/images/education-web/prongs.png';
import Shared from '../../Assets/images/education-web/shared.png';
import Channel from '../../Assets/images/education-web/channel.png';
import BarChannel from '../../Assets/images/education-web/bar-channel.png';
import Prave from '../../Assets/images/education-web/prave-setting.png';

import Bezel from '../../Assets/images/education-web/bezel.png';
import Engage from '../../Assets/images/education-web/engage.png';
import Help from './Components/help';
import Scrollspy from 'react-scrollspy';
import Metals from '../../Assets/images/education-web/metals.png';
import Img1 from '../../Assets/images/education-web/img-1.png';
import Img2 from '../../Assets/images/education-web/img-2.png';
import { Link } from 'react-router-dom';

import Loose from '../../Assets/images/education-web/loose.svg';
import Ring from '../../Assets/images/education-web/ring.svg';
import Gem from '../../Assets/images/education-web/gems.svg';
import Fine from '../../Assets/images/education-web/fine.svg';

import Pave from '../../Assets/images/education-web/pave.png';
import ChannelSet from '../../Assets/images/education-web/channel-set.png';
import SideStone from '../../Assets/images/education-web/sidestone.png';
import ThreeStone from '../../Assets/images/education-web/three-stone.png';
import Tension from '../../Assets/images/education-web/tension.png';
import Halo from '../../Assets/images/education-web/halo.png';
import Vintage from '../../Assets/images/education-web/vintage.png';
import Solitaire from '../../Assets/images/education-web/solitaire.png';

const EngagementRingEducation = () => {
  return (
    <>
        <Banner title={'Engagement Rings'} bannerImg={EngBan} nestedBreadCrumb />

        <div className='content-wrapper engagement-rings'>
            <Container>
                <ul className='education-tabs'>
                    <li className=''>
                        <Link to="/education/loose-diamonds-education">
                            <img src={Loose} alt='Loose' />
                            <h3>Loose Diamonds</h3>
                        </Link>
                    </li>

                    <li className='active'>
                        <Link to="/education/engagement-ring-education">
                            <img src={Ring}  alt='Loose' />
                            <h3>Engagement Ring</h3>
                        </Link>
                    </li>

                    <li>
                        <Link to="/education/gemstone-education">
                            <img src={Gem}  alt='Loose' />
                            <h3>Gemstones</h3>
                        </Link>
                    </li>

                    <li>
                        <Link to="/education/wedding-ring-education">
                            <img src={Ring} alt='Loose' />
                            <h3>Wedding Ring</h3>
                        </Link>
                    </li>

                    <li>
                        <Link to="/education/fine-jewelry-education">
                            <img src={Fine} alt='fine' />
                            <h3>Fine Jewelry</h3>
                        </Link>
                    </li>
                </ul>
            </Container>

            <Container>
                <h2 className='heading'>Table of Content</h2>
                <ul className='table-of-content mt-4'>
                    <li>
                        <a href="#section-1">
                            <h4>Ring Types</h4>
                            <p>To choose the perfect ring, consider what fits her lifestyle and personality.</p>
                            <img src={Engage} alt='Loose' />
                        </a>
                    </li>
                    <li>
                        <a href="#section-2">
                            <h4>Setting Types</h4>
                            <p>The style preferences, lifestyle, and personality of your partner.</p>
                            <img src={Engage}  alt='Loose'/>
                        </a>
                    </li>
                    <li>
                        <a href="#section-3">
                            <h4>Ring Sizing</h4>
                            <p>Your ring should fit easily not very tight, yet not very free either.</p>
                            <img src={Engage}  alt='Loose'/>
                        </a>
                    </li>
                    <li>
                        <a href="#section-4">
                            <h4>Metals</h4>
                            <p>Choosing the right metal is a crucial part of the ring-design process.</p>
                            <img src={Engage}  alt='Loose' />
                        </a>
                    </li>
                </ul>
            </Container>

            <Row className='m-0 main-content'>
                <Col xl={2} className='p-0 d-xl-block d-none'>
                    <div className='sticky-breadcrumb mt-100 px-5'>
                        <h4>Table of Content</h4>
                        <Scrollspy offset={200} items={ ['section-1', 'section-2', 'section-3', 'section-4'] } currentClassName="is-current">
                            <li><a href="#section-1">Ring Types</a></li>
                            <li><a href="#section-2">Setting Types</a></li>
                            <li><a href="#section-3">Ring Sizing</a></li>
                            <li><a href="#section-4">Metals</a></li>
                        </Scrollspy>
                    </div>
                </Col>

                <Col xl={8} lg={12} className='px-3'>
                    <h2 className='heading mt-80' id="section-1">Ring Types</h2>
                    <div className='ring-type-wrapper'>
                        <Row className='mt-3'>
                            <Col md={5}></Col>
                            <Col md={2} xs={3} className='text-md-center text-left mb-md-0 mb-3 align-self-center'>
                            <img src={Img1} alt='Loose' /></Col>
                            <Col md={5} xs={9}>
                                <h2>Solitaire Engagement Rings</h2>
                                <p>A solitaire ring setting features a single stone, typically a diamond with a plain mounting (usually four or six prongs). Solitaires are one of the most popular engagement ring settings. Their appeal is in their elegance, simplicity, and timelessness</p>
                            </Col>
                        </Row>

                        <Row className='mt-3'>
                            <Col md={5} xs={9} className='text-md-right text-left order-md-1 order-2'>
                                <h2>Pavé Engagement Rings</h2>
                                <p>A pavé engagement ring is encrusted with very small diamonds all along the band to give the appearance of a solid diamond surface. Because pave-set diamonds use only tiny beads or prongs to hold them in place, very little of the metal band shows through and the diamonds appear to</p>
                            </Col>
                            <Col md={2} xs={3} className='text-md-center text-right mb-md-0 mb-3 order-md-2 order-1 align-self-center'>
                            <img src={Pave} alt='Loose' /></Col>
                            <Col md={5} className='order-md-3 order-3'></Col>
                        </Row>

                        <Row className='mt-3'>
                            <Col md={5}></Col>
                            <Col md={2} xs={3} className='text-md-center text-left mb-md-0 mb-3 align-self-center'>
                            <img src={ChannelSet} alt='Loose' /></Col>
                            <Col md={5} xs={9}>
                                <h2>Channel Set Engagement Rings</h2>
                                <p>A solitaire ring setting features a single stone, typically a diamond with a plain mounting (usually four or six prongs). Solitaires are one of the most popular engagement ring settings. Their appeal is in their elegance, simplicity, and timelessness.</p>
                            </Col>
                        </Row>

                        <Row className='mt-3'>
                            <Col md={5} xs={9} className='text-md-right text-left order-md-1 order-2'>
                                <h2>Sidestone Engagement Rings</h2>
                                <p>A pavé engagement ring is encrusted with very small diamonds all along the band to give the appearance of a solid diamond surface. Because pave-set diamonds use only tiny beads or prongs to hold them in place, very little of the metal band shows through and the diamonds appear to.</p>
                            </Col>
                            <Col md={2} xs={3} className='text-md-center text-right mb-md-0 mb-3 order-md-2 order-1 align-self-center'>
                            <img src={SideStone} alt='Loose' /></Col>
                            <Col md={5} className='order-md-3 order-3'></Col>
                        </Row>

                        <Row className='mt-3'>
                            <Col md={5}></Col>
                            <Col md={2} xs={3} className='text-md-center text-left mb-md-0 mb-3 align-self-center'>
                            <img src={ThreeStone} alt='Loose' /></Col>
                            <Col md={5} xs={9}>
                                <h2>Three-Stone Engagement Rings</h2>
                                <p>A solitaire ring setting features a single stone, typically a diamond with a plain mounting (usually four or six prongs). Solitaires are one of the most popular engagement ring settings. Their appeal is in their elegance, simplicity, and timelessness.</p>
                            </Col>
                        </Row>

                        <Row className='mt-3'>
                            <Col md={5} xs={9} className='text-md-right text-left order-md-1 order-2'>
                                <h2>Tension Set Engagement Rings</h2>
                                <p>A pavé engagement ring is encrusted with very small diamonds all along the band to give the appearance of a solid diamond surface. Because pave-set diamonds use only tiny beads or prongs to hold them in place, very little of the metal band shows through and the diamonds appear to.</p>
                            </Col>
                            <Col md={2} xs={3} className='text-md-center text-right mb-md-0 mb-3 order-md-2 order-1 align-self-center'>
                            <img src={Tension} alt='Loose' /></Col>
                            <Col md={5} className='order-md-3 order-3'></Col>
                        </Row>

                        <Row className='mt-3'>
                            <Col md={5}></Col>
                            <Col md={2} xs={3} className='text-md-center text-left mb-md-0 mb-3 align-self-center'><img src={Halo} alt='Loose' /></Col>
                            <Col md={5} xs={9}>
                                <h2>Halo Engagement Rings</h2>
                                <p>A solitaire ring setting features a single stone, typically a diamond with a plain mounting (usually four or six prongs). Solitaires are one of the most popular engagement ring settings. Their appeal is in their elegance, simplicity, and timelessness.</p>
                            </Col>
                        </Row>

                        <Row className='mt-3'>
                            <Col md={5} xs={9} className='text-md-right text-left order-md-1 order-2'>
                                <h2>Vintage Engagement Rings</h2>
                                <p>A pavé engagement ring is encrusted with very small diamonds all along the band to give the appearance of a solid diamond surface. Because pave-set diamonds use only tiny beads or prongs to hold them in place, very little of the metal band shows through and the diamonds appear to.</p>
                            </Col>
                            <Col md={2} xs={3} className='text-md-center text-right mb-md-0 mb-3 order-md-2 order-1 align-self-center'>
                            <img src={Vintage} alt='Loose' /></Col>
                            <Col md={5} className='order-md-3 order-3'></Col>
                        </Row>
                    </div>

                    <h2 id='section-2' className='heading mt-100 mb-4'>Setting Types</h2>
                    <p>An engagement ring should be a reflection of the person wearing it.</p>
                    <p>Here are a few tips to help begin:</p>
                    <p>A woman with simpler, more streamlined taste may prefer a beautifully-made solitaire setting with one fantastic diamond. For women who like a lot of sparkle, an intricate pave setting with rows of diamonds might be preferable. A vintage setting with delicate engraving might appeal to a woman who has a penchant for the classics. Beautiful baguette side stones give a more contemporary feel to a ring, and gemstone settings are great for a woman who loves color. Tension settings will likely appeal to a more modern woman. Consider the woman, and the right style will become clear. Remember that the wedding band that will follow will need to match the engagement ring in terms of style and metal. The width of the ring is also a factor, since it will soon have a wedding ring next to it. A woman with small hands will want a narrower band on her rings, while a woman with larger hands might prefer a wider band.</p>

                    <Row className='mt-40'>
                        <Col md={4}>
                            <img src={Prongs} alt='Loose' />
                        </Col>
                        <Col className='align-self-center'>
                            <h2 className='sub-heading'>Prongs</h2>
                            <p>In this classic setting, two or more prongs wrap around the crown of a stone to secure it in place. Also known as a claw setting, this mounting style minimizes the amount of metal used, allowing more light to pass through a diamond or gemstone. Four prongs are most desirable for setting princes diamonds, and other cuts with delicate corners</p>
                        </Col>
                    </Row>

                    <Row className='mt-40 flex-row-reverse'>
                        <Col md={4}>
                            <img src={Shared} alt='Loose' />
                        </Col>
                        <Col className='align-self-center'>
                            <h2 className='sub-heading'>Shared</h2>
                            <p>In a variation of the classic prong setting, prongs are wrapped around the crown of a stone to secure it in place. This type of setting minimizes the presence of metal, allowing more light to pass through a diamond or gemstone.</p>
                        </Col>
                    </Row>

                    <Row className='mt-40'>
                        <Col md={4}>
                            <img src={Channel} alt='Loose' />
                        </Col>
                        <Col className='align-self-center'>
                            <h2 className='sub-heading'>Channel</h2>
                            <p>Diamonds or gemstones are secured in place between vertical metal walls, creating a smooth channel. In this contemporary setting, the stones are nestled side by side with no metal in between.</p>
                        </Col>
                    </Row>

                    <Row className='mt-40 flex-row-reverse'>
                        <Col md={4}>
                            <img src={BarChannel} alt='Loose' />
                        </Col>
                        <Col className='align-self-center'>
                            <h2 className='sub-heading'>Bar Channel</h2>
                            <p>In this more secure variation of the traditional channel setting, diamonds or gemstones are secured in place between two vertical metal walls on either side of each diamond.</p>
                        </Col>
                    </Row>

                    <Row className='mt-40'>
                        <Col md={4}>
                            <img src={Prave}  alt='Loose' />
                        </Col>
                        <Col className='align-self-center'>
                            <h2 className='sub-heading'>Pave Settings</h2>
                            <p>In this dramatically elegant setting type, diamonds or gemstones are set low and very close together using tiny beads. The surface of the ring will appear to be encrusted with stones for a brilliant effect.</p>
                        </Col>
                    </Row>

                    <Row className='mt-40 flex-row-reverse'>
                        <Col md={4}>
                            <img src={Bezel} alt='Loose' />
                        </Col>
                        <Col className='align-self-center'>
                            <h2 className='sub-heading'>Bezel Settings</h2>
                            <p>A metal rim surrounds a diamond or gemstone by the girdle to secure it in place. This dramatic setting style can create the illusion of a larger stone.</p>
                        </Col>
                    </Row>

                    <h2 id='section-3' className='mt-100 heading'>Ring Sizing</h2>
                    <p>Your engagement ring or wedding band should fit comfortably — not too tight, but not too loose either. The perfect ring fits loose enough to slide over your knuckle and tight enough so that it cannot fall off your finger. To find your ring size, you can use online ring sizer or request a free plastic ring sizer. Keep reading for tips on how to measure your finger size and make sure that you purchase a ring that fits just right.</p>

                    <h2 className='sub-heading mt-30'>Online Ring Sizing:</h2>
                    <p>Sizing an engagement ring is easier than you think. offers a free online ring sizer to help you determine your ring size. The online ring sizer is easy to use and offers two options; you can find your ring size by using the ring sizer to measure your finger or you can measure a ring that you already have. Both are accurate and will give you your exact ring size. If for some reason, the ring you order does not fit comfortably, don't worry! will resize your ring once for free within the first year of your purchase, including free return shipping within the U.S. and Canada for the first resize.</p>
                    <p>*Some rings cannot be resized and will need to be remanufactured. There will be a fee for rings that need to be remanufactured outside the 30-day return policy.</p>

                    <h2 className='sub-heading mt-30'>Tips for Finding Your Ring Size:</h2>
                    <ol className='pl-4 mt-3'>
                        <li><h6>Measure your finger at the end of the day.</h6><p>Your finger size changes depending on the weather and time of day. For best results, measure your finger size at the end of the day when your fingers are warm. (Early in the morning, your fingers are cold and therefore smaller.</p></li>
                        <li><h6>Measure a few times</h6><p>Be sure to measure your finger size a few times to make sure your calculations are accurate.</p></li>
                    </ol>

                    <h2 className='sub-heading mt-30'>Tips for Buying a Ring as a Surprise:</h2>
                    <ol className='pl-4 mt-3'>
                        <li><p>If you don't know your girlfriend's (or boyfriend's) ring size, ask her/his close friends or family members. Tell them to keep it hush-hush so that they don't accidentialy ruin the surprise!</p></li>
                        <li><p>Borrow his/her ring (from the correct finger!) and use  online or plastic ring sizer to determine the ring's size.</p></li>
                    </ol>
                    <p>Remember, you can have a resize your ring once for free within the first year of your purchase, including free return shipping within the U.S. and Canada for the first resize. For more information regarding ring sizing, feel free to contact customer service, available 24/7.</p>

                    <h2 id='section-4' className='heading mt-80'>Metals</h2>
                    <p>Choosing the right metal for an engagement ring is a crucial part of the ring-design process. Once you know a bit about the basics of ring metals, deciding on a metal is a rewarding and simple process. Choosing between white gold, yellow gold, or platinum is as much as matter of personal preference as it is of budget. Before you make a final decision, it is worth weighing the pros and cons of the various types of engagement ring metals.</p>

                    <div className='metal-wrapper position-relative'>
                        <Row className='mt-40'>
                            <Col md={4}>
                                <h2 className='sub-heading'>White Gold</h2>
                                <p>White gold is an incredibly beautiful and popular choice for engagement ring settings, which is quickly becoming the number one choice in engagement ring metals. White gold has the overall look of platinum, but is notably less expensive. White gold beautifully compliments diamonds that are rated D-I on the diamond color scale, as it enhances the brilliance and sparkle of the stone.</p>
                            </Col>
                            <Col md={4}></Col>
                            <Col md={4}>
                                <h2 className='sub-heading'>Rose Gold</h2>
                                <p>Rose gold is a gold and copper alloy commonly used for specialized jewelry and coveted for its warm, reddish color. Rose gold is also known as red gold and pink gold, and sometimes as Russian gold, as a result of its popularity in Russia in the early 19th century. The difference between red, rose and pink gold is their copper content.</p>
                            </Col>
                        </Row>
                        <img src={Metals} alt='Loose' />
                        <Row className=''>
                            <Col md={4}>
                                <h2 className='sub-heading'>Platinum</h2>
                                <p>Platinum is a rare and valuable metal that is only found in limited quantities in a few, select regions of the world. The annual worldwide production of platinum is approximately 160 tons, compared to 1,500 tons of gold. This is why platinum is more expensive than the other precious metals.</p>
                            </Col>
                            <Col md={4}></Col>
                            <Col md={4}>
                                <h2 className='sub-heading'>Yellow Gold</h2>
                                <p>Yellow gold is the most common of the golds, partly because gold is yellow in its naturally occurring state. The yellow gold used in fine jewelry is typically alloyed with silver and copper; its color depends on the amount of pure gold in the alloy. The advantages of gold are that is does not corrode, tarnish or rust, so it can be counted on to provide lasting beauty. And even though it is strong, gold is more "flexible" than the other precious metals.</p>
                            </Col>
                        </Row>
                    </div>
                </Col>
            </Row>
                

            <Container>
                <Help />
            </Container>
        </div>
    </>
    
  )
}

export default EngagementRingEducation;